const provinceData = [
    {
      code: "110000",
      label: "北京市",
      children: [
        {
          code: "110100",
          label: "北京市"
        }
      ],
    },
    {
      code: "120000",
      label: "天津市",
      children: [
        {
          code: "120100",
          label: "天津市"
        },
      ],
    },
    {
      code: "130000",
      label: "河北省",
      children: [
        {
          code: "130100",
          label: "石家庄市",
        },
        {
          code: "130200",
          label: "唐山市",
        },
        {
          code: "130300",
          label: "秦皇岛市",
        },
        {
          code: "130400",
          label: "邯郸市",
        },
        {
          code: "130500",
          label: "邢台市",
        },
        {
          code: "130600",
          label: "保定市",
        },
        {
          code: "130700",
          label: "张家口市",
        },
        {
          code: "130800",
          label: "承德市",
        },
        {
          code: "130900",
          label: "沧州市",
        },
        {
          code: "131000",
          label: "廊坊市",
        },
        {
          code: "131100",
          label: "衡水市",
        },
      ],
    },
    {
      code: "140000",
      label: "山西省",
      children: [
        {
          code: "140100",
          label: "太原市",
        },
        {
          code: "140200",
          label: "大同市",
        },
        {
          code: "140300",
          label: "阳泉市",
        },
        {
          code: "140400",
          label: "长治市",
        },
        {
          code: "140500",
          label: "晋城市",
        },
        {
          code: "140600",
          label: "朔州市",
        },
        {
          code: "140700",
          label: "晋中市",
        },
        {
          code: "140800",
          label: "运城市",
        },
        {
          code: "140900",
          label: "忻州市",
        },
        {
          code: "141000",
          label: "临汾市",
        },
        {
          code: "141100",
          label: "吕梁市",
        },
      ],
    },
    {
      code: "150000",
      label: "内蒙古自治区",
      children: [
        {
          code: "150100",
          label: "呼和浩特市",
        },
        {
          code: "150200",
          label: "包头市",
        },
        {
          code: "150300",
          label: "乌海市",
        },
        {
          code: "150400",
          label: "赤峰市",
        },
        {
          code: "150500",
          label: "通辽市",
        },
        {
          code: "150600",
          label: "鄂尔多斯市",
        },
        {
          code: "150700",
          label: "呼伦贝尔市",
        },
        {
          code: "150800",
          label: "巴彦淖尔市",
        },
        {
          code: "150900",
          label: "乌兰察布市",
        },
        {
          code: "152200",
          label: "兴安盟",
        },
        {
          code: "152500",
          label: "锡林郭勒盟",
        },
        {
          code: "152900",
          label: "阿拉善盟",
        },
      ],
    },
    {
      code: "210000",
      label: "辽宁省",
      children: [
        {
          code: "210100",
          label: "沈阳市",
        },
        {
          code: "210200",
          label: "大连市",
        },
        {
          code: "210300",
          label: "鞍山市",
        },
        {
          code: "210400",
          label: "抚顺市",
        },
        {
          code: "210500",
          label: "本溪市",
        },
        {
          code: "210600",
          label: "丹东市",
        },
        {
          code: "210700",
          label: "锦州市",
        },
        {
          code: "210800",
          label: "营口市",
        },
        {
          code: "210900",
          label: "阜新市",
        },
        {
          code: "211000",
          label: "辽阳市",
        },
        {
          code: "211100",
          label: "盘锦市",
        },
        {
          code: "211200",
          label: "铁岭市",
        },
        {
          code: "211300",
          label: "朝阳市",
        },
        {
          code: "211400",
          label: "葫芦岛市",
        },
      ],
    },
    {
      code: "220000",
      label: "吉林省",
      children: [
        {
          code: "220100",
          label: "长春市",
        },
        {
          code: "220200",
          label: "吉林市",
        },
        {
          code: "220300",
          label: "四平市",
        },
        {
          code: "220400",
          label: "辽源市",
        },
        {
          code: "220500",
          label: "通化市",
        },
        {
          code: "220600",
          label: "白山市",
        },
        {
          code: "220700",
          label: "松原市",
        },
        {
          code: "220800",
          label: "白城市",
        },
        {
          code: "222400",
          label: "延边朝鲜族自治州",
        },
      ],
    },
    {
      code: "230000",
      label: "黑龙江省",
      children: [
        {
          code: "230100",
          label: "哈尔滨市",
        },
        {
          code: "230200",
          label: "齐齐哈尔市",
        },
        {
          code: "230300",
          label: "鸡西市",
        },
        {
          code: "230400",
          label: "鹤岗市",
        },
        {
          code: "230500",
          label: "双鸭山市",
        },
        {
          code: "230600",
          label: "大庆市",
        },
        {
          code: "230700",
          label: "伊春市",
        },
        {
          code: "230800",
          label: "佳木斯市",
        },
        {
          code: "230900",
          label: "七台河市",
        },
        {
          code: "231000",
          label: "牡丹江市",
        },
        {
          code: "231100",
          label: "黑河市",
        },
        {
          code: "231200",
          label: "绥化市",
        },
        {
          code: "232700",
          label: "大兴安岭地区",
        },
      ],
    },
    {
      code: "310000",
      label: "上海市",
      children: [
        {
          code: "310100",
          label: "上海市"
        },
      ],
    },
    {
      code: "320000",
      label: "江苏省",
      children: [
        {
          code: "320100",
          label: "南京市",
        },
        {
          code: "320200",
          label: "无锡市",
        },
        {
          code: "320300",
          label: "徐州市",
        },
        {
          code: "320400",
          label: "常州市",
        },
        {
          code: "320500",
          label: "苏州市",
        },
        {
          code: "320600",
          label: "南通市",
        },
        {
          code: "320700",
          label: "连云港市",
        },
        {
          code: "320800",
          label: "淮安市",
        },
        {
          code: "320900",
          label: "盐城市",
        },
        {
          code: "321000",
          label: "扬州市",
        },
        {
          code: "321100",
          label: "镇江市",
        },
        {
          code: "321200",
          label: "泰州市",
        },
        {
          code: "321300",
          label: "宿迁市",
        },
      ],
    },
    {
      code: "330000",
      label: "浙江省",
      children: [
        {
          code: "330100",
          label: "杭州市",
        },
        {
          code: "330200",
          label: "宁波市",
        },
        {
          code: "330300",
          label: "温州市",
        },
        {
          code: "330400",
          label: "嘉兴市",
        },
        {
          code: "330500",
          label: "湖州市",
        },
        {
          code: "330600",
          label: "绍兴市",
        },
        {
          code: "330700",
          label: "金华市",
        },
        {
          code: "330800",
          label: "衢州市",
        },
        {
          code: "330900",
          label: "舟山市",
        },
        {
          code: "331000",
          label: "台州市",
        },
        {
          code: "331100",
          label: "丽水市",
        },
      ],
    },
    {
      code: "340000",
      label: "安徽省",
      children: [
        {
          code: "340100",
          label: "合肥市",
        },
        {
          code: "340200",
          label: "芜湖市",
        },
        {
          code: "340300",
          label: "蚌埠市",
        },
        {
          code: "340400",
          label: "淮南市",
        },
        {
          code: "340500",
          label: "马鞍山市",
        },
        {
          code: "340600",
          label: "淮北市",
        },
        {
          code: "340700",
          label: "铜陵市",
        },
        {
          code: "340800",
          label: "安庆市",
        },
        {
          code: "341000",
          label: "黄山市",
        },
        {
          code: "341100",
          label: "滁州市",
        },
        {
          code: "341200",
          label: "阜阳市",
        },
        {
          code: "341300",
          label: "宿州市",
        },
        {
          code: "341500",
          label: "六安市",
        },
        {
          code: "341600",
          label: "亳州市",
        },
        {
          code: "341700",
          label: "池州市",
        },
        {
          code: "341800",
          label: "宣城市",
        },
      ],
    },
    {
      code: "350000",
      label: "福建省",
      children: [
        {
          code: "350100",
          label: "福州市",
        },
        {
          code: "350200",
          label: "厦门市",
        },
        {
          code: "350300",
          label: "莆田市",
        },
        {
          code: "350400",
          label: "三明市",
        },
        {
          code: "350500",
          label: "泉州市",
        },
        {
          code: "350600",
          label: "漳州市",
        },
        {
          code: "350700",
          label: "南平市",
        },
        {
          code: "350800",
          label: "龙岩市",
        },
        {
          code: "350900",
          label: "宁德市",
        },
      ],
    },
    {
      code: "360000",
      label: "江西省",
      children: [
        {
          code: "360100",
          label: "南昌市",
        },
        {
          code: "360200",
          label: "景德镇市",
        },
        {
          code: "360300",
          label: "萍乡市",
        },
        {
          code: "360400",
          label: "九江市",
        },
        {
          code: "360500",
          label: "新余市",
        },
        {
          code: "360600",
          label: "鹰潭市",
        },
        {
          code: "360700",
          label: "赣州市",
        },
        {
          code: "360800",
          label: "吉安市",
        },
        {
          code: "360900",
          label: "宜春市",
        },
        {
          code: "361000",
          label: "抚州市",
        },
        {
          code: "361100",
          label: "上饶市",
        },
      ],
    },
    {
      code: "370000",
      label: "山东省",
      children: [
        {
          code: "370100",
          label: "济南市",
        },
        {
          code: "370200",
          label: "青岛市",
        },
        {
          code: "370300",
          label: "淄博市",
        },
        {
          code: "370400",
          label: "枣庄市",
        },
        {
          code: "370500",
          label: "东营市",
        },
        {
          code: "3706",
          label: "烟台市",
        },
        {
          code: "370700",
          label: "潍坊市",
        },
        {
          code: "370800",
          label: "济宁市",
        },
        {
          code: "370900",
          label: "泰安市",
        },
        {
          code: "371000",
          label: "威海市",
        },
        {
          code: "371100",
          label: "日照市",
        },
        {
          code: "371300",
          label: "临沂市",
        },
        {
          code: "371400",
          label: "德州市",
        },
        {
          code: "371500",
          label: "聊城市",
        },
        {
          code: "371600",
          label: "滨州市",
        },
        {
          code: "371700",
          label: "菏泽市",
        },
      ],
    },
    {
      code: "410000",
      label: "河南省",
      children: [
        {
          code: "410100",
          label: "郑州市",
        },
        {
          code: "410200",
          label: "开封市",
        },
        {
          code: "410300",
          label: "洛阳市",
        },
        {
          code: "410400",
          label: "平顶山市",
        },
        {
          code: "410500",
          label: "安阳市",
        },
        {
          code: "410600",
          label: "鹤壁市",
        },
        {
          code: "410700",
          label: "新乡市",
        },
        {
          code: "410800",
          label: "焦作市",
        },
        {
          code: "410900",
          label: "濮阳市",
        },
        {
          code: "411000",
          label: "许昌市",
        },
        {
          code: "411100",
          label: "漯河市",
        },
        {
          code: "411200",
          label: "三门峡市",
        },
        {
          code: "411300",
          label: "南阳市",
        },
        {
          code: "411400",
          label: "商丘市",
        },
        {
          code: "411500",
          label: "信阳市",
        },
        {
          code: "411600",
          label: "周口市",
        },
        {
          code: "411700",
          label: "驻马店市",
        },
        {
          code: "419000",
          label: "省直辖县级行政区划",
          children: [{ code: "419001", label: "济源市" }],
        },
      ],
    },
    {
      code: "420000",
      label: "湖北省",
      children: [
        {
          code: "420100",
          label: "武汉市",
        },
        {
          code: "420200",
          label: "黄石市",
        },
        {
          code: "420300",
          label: "十堰市",
        },
        {
          code: "420500",
          label: "宜昌市",
        },
        {
          code: "420600",
          label: "襄阳市",
        },
        {
          code: "420700",
          label: "鄂州市",
        },
        {
          code: "420800",
          label: "荆门市",
        },
        {
          code: "420900",
          label: "孝感市",
        },
        {
          code: "421000",
          label: "荆州市",
        },
        {
          code: "421100",
          label: "黄冈市",
        },
        {
          code: "421200",
          label: "咸宁市",
        },
        {
          code: "421300",
          label: "随州市",
        },
        {
          code: "422800",
          label: "恩施土家族苗族自治州",
        },
        {
          code: "429000",
          label: "省直辖县级行政区划",
        },
      ],
    },
    {
      code: "430000",
      label: "湖南省",
      children: [
        {
          code: "430100",
          label: "长沙市",
        },
        {
          code: "430200",
          label: "株洲市",
        },
        {
          code: "430300",
          label: "湘潭市",
        },
        {
          code: "430400",
          label: "衡阳市",
        },
        {
          code: "430500",
          label: "邵阳市",
        },
        {
          code: "430600",
          label: "岳阳市",
        },
        {
          code: "430700",
          label: "常德市",
        },
        {
          code: "430800",
          label: "张家界市",
        },
        {
          code: "430900",
          label: "益阳市",
        },
        {
          code: "431000",
          label: "郴州市",
        },
        {
          code: "431100",
          label: "永州市",
        },
        {
          code: "431200",
          label: "怀化市",
        },
        {
          code: "431300",
          label: "娄底市",
        },
        {
          code: "433100",
          label: "湘西土家族苗族自治州",
        },
      ],
    },
    {
      code: "440000",
      label: "广东省",
      children: [
        {
          code: "440100",
          label: "广州市",
        },
        {
          code: "440200",
          label: "韶关市",
        },
        {
          code: "440300",
          label: "深圳市",
        },
        {
          code: "440400",
          label: "珠海市",
        },
        {
          code: "440500",
          label: "汕头市",
        },
        {
          code: "440600",
          label: "佛山市",
        },
        {
          code: "440700",
          label: "江门市",
        },
        {
          code: "440800",
          label: "湛江市",
        },
        {
          code: "440900",
          label: "茂名市",
        },
        {
          code: "441200",
          label: "肇庆市",
        },
        {
          code: "441300",
          label: "惠州市",
        },
        {
          code: "441400",
          label: "梅州市",
        },
        {
          code: "441500",
          label: "汕尾市",
        },
        {
          code: "441600",
          label: "河源市",
        },
        {
          code: "441700",
          label: "阳江市",
        },
        {
          code: "441800",
          label: "清远市",
        },
        {
          code: "441900",
          label: "东莞市",
        },
        {
          code: "442000",
          label: "中山市",
        },
        {
          code: "445100",
          label: "潮州市",
        },
        {
          code: "445200",
          label: "揭阳市",
        },
        {
          code: "445300",
          label: "云浮市",
        },
      ],
    },
    {
      code: "450000",
      label: "广西壮族自治区",
      children: [
        {
          code: "450100",
          label: "南宁市",
        },
        {
          code: "450200",
          label: "柳州市",
        },
        {
          code: "450300",
          label: "桂林市",
        },
        {
          code: "450400",
          label: "梧州市",
        },
        {
          code: "450500",
          label: "北海市",
        },
        {
          code: "450600",
          label: "防城港市",
        },
        {
          code: "450700",
          label: "钦州市",
        },
        {
          code: "450800",
          label: "贵港市",
        },
        {
          code: "450900",
          label: "玉林市",
        },
        {
          code: "451000",
          label: "百色市",
        },
        {
          code: "451100",
          label: "贺州市",
        },
        {
          code: "451200",
          label: "河池市",
        },
        {
          code: "451300",
          label: "来宾市",
        },
        {
          code: "451400",
          label: "崇左市",
        },
      ],
    },
    {
      code: "460000",
      label: "海南省",
      children: [
        {
          code: "460100",
          label: "海口市",
        },
        {
          code: "460200",
          label: "三亚市",
        },
        {
          code: "460300",
          label: "三沙市",
        },
        {
          code: "460400",
          label: "儋州市",
        },
        {
          code: "469000",
          label: "省直辖县级行政区划",
        },
      ],
    },
    {
      code: "500000",
      label: "重庆市",
      children: [
        {
          code: "500100",
          label: "重庆市",
        },
      ],
    },
    {
      code: "510000",
      label: "四川省",
      children: [
        {
          code: "510100",
          label: "成都市",
        },
        {
          code: "510300",
          label: "自贡市",
        },
        {
          code: "510400",
          label: "攀枝花市",
        },
        {
          code: "510500",
          label: "泸州市",
        },
        {
          code: "510600",
          label: "德阳市",
        },
        {
          code: "510700",
          label: "绵阳市",
        },
        {
          code: "510800",
          label: "广元市",
        },
        {
          code: "510900",
          label: "遂宁市",
        },
        {
          code: "511000",
          label: "内江市",
        },
        {
          code: "511100",
          label: "乐山市",
        },
        {
          code: "511300",
          label: "南充市",
        },
        {
          code: "511400",
          label: "眉山市",
        },
        {
          code: "511500",
          label: "宜宾市",
        },
        {
          code: "511600",
          label: "广安市",
        },
        {
          code: "511700",
          label: "达州市",
        },
        {
          code: "511800",
          label: "雅安市",
        },
        {
          code: "511900",
          label: "巴中市",
        },
        {
          code: "512000",
          label: "资阳市",
        },
        {
          code: "513200",
          label: "阿坝藏族羌族自治州",
        },
        {
          code: "513300",
          label: "甘孜藏族自治州",
        },
        {
          code: "513400",
          label: "凉山彝族自治州",
        },
      ],
    },
    {
      code: "520000",
      label: "贵州省",
      children: [
        {
          code: "520100",
          label: "贵阳市",
        },
        {
          code: "520200",
          label: "六盘水市",
        },
        {
          code: "520300",
          label: "遵义市",
        },
        {
          code: "520400",
          label: "安顺市",
        },
        {
          code: "520500",
          label: "毕节市",
        },
        {
          code: "520600",
          label: "铜仁市",
        },
        {
          code: "522300",
          label: "黔西南布依族苗族自治州",
        },
        {
          code: "522600",
          label: "黔东南苗族侗族自治州",
        },
        {
          code: "522700",
          label: "黔南布依族苗族自治州",
        },
      ],
    },
    {
      code: "530000",
      label: "云南省",
      children: [
        {
          code: "530100",
          label: "昆明市",
        },
        {
          code: "530300",
          label: "曲靖市",
        },
        {
          code: "530400",
          label: "玉溪市",
        },
        {
          code: "530500",
          label: "保山市",
        },
        {
          code: "530600",
          label: "昭通市",
        },
        {
          code: "530700",
          label: "丽江市",
        },
        {
          code: "530800",
          label: "普洱市",
        },
        {
          code: "530900",
          label: "临沧市",
        },
        {
          code: "532300",
          label: "楚雄彝族自治州",
        },
        {
          code: "532500",
          label: "红河哈尼族彝族自治州",
        },
        {
          code: "532600",
          label: "文山壮族苗族自治州",
        },
        {
          code: "532800",
          label: "西双版纳傣族自治州",
        },
        {
          code: "532900",
          label: "大理白族自治州",
        },
        {
          code: "533100",
          label: "德宏傣族景颇族自治州",
        },
        {
          code: "533300",
          label: "怒江傈僳族自治州",
        },
        {
          code: "533400",
          label: "迪庆藏族自治州",
        },
      ],
    },
    {
      code: "540000",
      label: "西藏自治区",
      children: [
        {
          code: "540100",
          label: "拉萨市",
        },
        {
          code: "540200",
          label: "日喀则市",
        },
        {
          code: "540300",
          label: "昌都市",
        },
        {
          code: "540400",
          label: "林芝市",
        },
        {
          code: "540500",
          label: "山南市",
        },
        {
          code: "540600",
          label: "那曲市",
        },
        {
          code: "542500",
          label: "阿里地区",
        },
      ],
    },
    {
      code: "610000",
      label: "陕西省",
      children: [
        {
          code: "610100",
          label: "西安市",
        },
        {
          code: "610200",
          label: "铜川市",
        },
        {
          code: "610300",
          label: "宝鸡市",
        },
        {
          code: "610400",
          label: "咸阳市",
        },
        {
          code: "610500",
          label: "渭南市",
        },
        {
          code: "610600",
          label: "延安市",
        },
        {
          code: "610700",
          label: "汉中市",
        },
        {
          code: "610800",
          label: "榆林市",
        },
        {
          code: "610900",
          label: "安康市",
        },
        {
          code: "611000",
          label: "商洛市",
        },
      ],
    },
    {
      code: "620000",
      label: "甘肃省",
      children: [
        {
          code: "620100",
          label: "兰州市",
        },
        {
          code: "620200",
          label: "嘉峪关市",
        },
        {
          code: "620300",
          label: "金昌市",
        },
        {
          code: "620400",
          label: "白银市",
        },
        {
          code: "620500",
          label: "天水市",
        },
        {
          code: "620600",
          label: "武威市",
        },
        {
          code: "620700",
          label: "张掖市",
        },
        {
          code: "620800",
          label: "平凉市",
        },
        {
          code: "620900",
          label: "酒泉市",
        },
        {
          code: "621000",
          label: "庆阳市",
        },
        {
          code: "621100",
          label: "定西市",
        },
        {
          code: "621200",
          label: "陇南市",
        },
        {
          code: "622900",
          label: "临夏回族自治州",
        },
        {
          code: "623000",
          label: "甘南藏族自治州",
        },
      ],
    },
    {
      code: "630000",
      label: "青海省",
      children: [
        {
          code: "630100",
          label: "西宁市",
        },
        {
          code: "630200",
          label: "海东市",
        },
        {
          code: "632200",
          label: "海北藏族自治州",
        },
        {
          code: "632300",
          label: "黄南藏族自治州",
        },
        {
          code: "632500",
          label: "海南藏族自治州",
        },
        {
          code: "632600",
          label: "果洛藏族自治州",
        },
        {
          code: "632700",
          label: "玉树藏族自治州",
        },
        {
          code: "632800",
          label: "海西蒙古族藏族自治州",
        },
      ],
    },
    {
      code: "640000",
      label: "宁夏回族自治区",
      children: [
        {
          code: "640100",
          label: "银川市",
        },
        {
          code: "640200",
          label: "石嘴山市",
        },
        {
          code: "640300",
          label: "吴忠市",
        },
        {
          code: "640400",
          label: "固原市",
        },
        {
          code: "640500",
          label: "中卫市",
        },
      ],
    },
    {
      code: "650000",
      label: "新疆维吾尔自治区",
      children: [
        {
          code: "650100",
          label: "乌鲁木齐市",
         
        },
        {
          code: "650200",
          label: "克拉玛依市",
          
        },
        {
          code: "650400",
          label: "吐鲁番市",
          
        },
        {
          code: "650500",
          label: "哈密市",
          
        },
        {
          code: "652300",
          label: "昌吉回族自治州",
         
        },
        {
          code: "652700",
          label: "博尔塔拉蒙古自治州",
        },
        {
          code: "652800",
          label: "巴音郭楞蒙古自治州",
        },
        {
          code: "652900",
          label: "阿克苏地区",
        },
        {
          code: "653000",
          label: "克孜勒苏柯尔克孜自治州",
        },
        {
          code: "653100",
          label: "喀什地区",
        },
        {
          code: "653200",
          label: "和田地区",
        },
        {
          code: "654000",
          label: "伊犁哈萨克自治州",
        },
        {
          code: "654200",
          label: "塔城地区",
        },
        {
          code: "654300",
          label: "阿勒泰地区",
        },
        {
          code: "659000",
          label: "自治区直辖县级行政区划",
        },
      ],
    },
  ];
  
  export default provinceData